import { Route } from '../types/route.types';
import { Filters } from '../types/filter.types';
import { matchesSkiFilters } from '../utils/filterUtils';

/**
 * Service métier pour les filtres
 */
export const filterService = {
  /**
   * Filtre les routes selon les critères
   */
  filterRoutes(routes: Route[], filters: Filters): Route[] {
    if (routes.length === 0) return [];

    // Filtre par activité
    if (filters.activities.length > 0) {
      const activity = filters.activities[0];
      routes = routes.filter(route => route.activities.includes(activity));

      // Filtres spécifiques au ski de randonnée
      if (activity === 'skitouring' && filters.skitouring) {
        routes = routes.filter(route => matchesSkiFilters(route, filters.skitouring!));
      }
    }

    return routes;
  },
};
